export default __webpack_public_path__ + "static/media/bannerImage.585977b1.jpeg";